/**
 * Get UTM parameters used as Amplitude Experiment user properties.
 *
 * @return {Object} UTM user properties.
 */
const getAmplitudeUtmProperties = function getAmplitudeUtmProperties() {

	const searchParams = new URLSearchParams( window.location.search );
	const utmParams = [
		'utm_source',
		'utm_medium',
		'utm_campaign',
		'utm_term',
		'utm_content',
	];

	return utmParams.reduce( function ( properties, param ) {

		const value = searchParams.get( param );

		if ( value ) {

			properties[ param ] = value;

		}

		return properties;

	}, {} );

};

window.opteryAmplitude = window.opteryAmplitude || {};

window.opteryAmplitude.analyticsInit = window?.amplitude?.init( window.opteryAmplitude.apiKey, {
	fetchRemoteConfig: true,
	autocapture: true,
} );

window.opteryAmplitude.analyticsInitPromise =
	window.opteryAmplitude.analyticsInit && window.opteryAmplitude.analyticsInit.promise;

if ( window.Experiment && ! window.opteryAmplitude.experimentClient ) {

	window.opteryAmplitude.experimentClient = window.Experiment.initializeWithAmplitudeAnalytics(
		window.opteryAmplitude.experimentDeploymentKey
	);

}

if (
	window.opteryAmplitude.experimentClient &&
	! window.opteryAmplitude.experimentFetchPromise &&
	typeof window.opteryAmplitude.experimentClient.fetch === 'function'
) {

	window.opteryAmplitude.experimentFetchPromise = ( window.opteryAmplitude.analyticsInitPromise || Promise.resolve() )
		.then( function () {

			const userProperties = getAmplitudeUtmProperties();

			if ( ! Object.keys( userProperties ).length ) {

				return window.opteryAmplitude.experimentClient.fetch();

			}

			return window.opteryAmplitude.experimentClient.fetch( {
				user_properties: userProperties,
			} );

		} )
		.catch( function () {

			return null;

		} );

}
